import { ICON_COLOR } from '../../Icon'

export function getUserMenuThemeModeArrowColor({ isHovered, isSelected }) {
  return isHovered || isSelected
    ? ICON_COLOR.ButtonBg
    : ICON_COLOR.SecondaryTextColor
}
